import React from "react";
import numeral from "numeral";

import styles from "./style.module.css";

import { getRange } from "aible";

import { AutoSizer } from "react-virtualized";

import { BarChart, Bar, Tooltip, XAxis, YAxis, ResponsiveContainer } from "recharts";

const CustomToolTip = (props) => {
  const { active, payload } = props;
  if (!active || !payload) {
    return null;
  }
  const payloadWrapper = payload && payload[0] && payload[0].payload;

  return (
    <div className={styles.toolTipWrapper}>
      <div className={styles.toolTopBody}>
        <strong>{payloadWrapper.x + ": "}</strong>
        {payloadWrapper.isPercentage ? (payloadWrapper.y * 100).toFixed(2) + "%" : payloadWrapper.y}
      </div>
    </div>
  );
};

export default class BarGraphs extends React.PureComponent {
  render() {
    const { data, adjustAssumptions, isContinuous, setupLabels, timePeriod } = this.props;
    if (!data) {
      return <div />;
    }
    return (
      <div className={styles.barGraphsWrapper}>
        <div className={styles.barGraphsContent}>
          <BarGraph
            title={setupLabels.transactionLabel}
            adjustAssumptions={() => adjustAssumptions("transactions")}
            data={data}
            assumed={"cumulativeAssumedTransactionCount"}
            actual={"cumulativeTransactionCount"}
          />
        </div>
        {isContinuous ? (
          <div className={styles.barGraphsContent} />
        ) : (
          <div className={styles.barGraphsContent}>
            <BarGraph
              title={setupLabels.outcomeLabel + " Rate"}
              adjustAssumptions={() => adjustAssumptions("conversion rate")}
              data={data}
              assumed={"cumulativeAssumedConversionRate"}
              actual={"cumulativeConversionRate"}
              isPercentage
            />
          </div>
        )}
      </div>
    );
  }
}

class BarGraph extends React.PureComponent {
  render() {
    const { data, assumed, actual, isPercentage, title, adjustAssumptions } = this.props;

    if (data[assumed] === undefined) {
      return <div />;
    }

    const retData = [
      { x: "Projected", y: data[assumed], color: "#EF7E54", isPercentage: isPercentage },
      { x: "Actual", y: data[actual], color: "#7E69D7", isPercentage: isPercentage }
    ];

    const yDataMin = Math.min.apply(
      Math,
      retData.map((p) => p.y || 0)
    );
    const yDataMax = Math.max.apply(
      Math,
      retData.map((p) => p.y || 0)
    );
    const yDomain = getRange(yDataMin * 0.9, yDataMax, true, isPercentage ? 1 : 2);
    yDomain[0] = 0;

    return (
      <React.Fragment>
        <BarGraphTitle title={title} adjustAssumptions={() => adjustAssumptions()} />
        <div className={styles.barGraphWrapper}>
          <AutoSizer>
            {({ width, height }) => (
              <BarChart
                width={width}
                height={height}
                margin={{
                  top: 10,
                  right: 30,
                  bottom: 0,
                  left: 10
                }}
                data={retData}
                onClick={() => {}}
                layout={"vertical"}
              >
                <YAxis type="category" dataKey={"x"} />
                <XAxis
                  type="number"
                  dataKey={"y"}
                  tickFormatter={(tick) =>
                    isPercentage
                      ? (tick * 100).toFixed(1) + "%"
                      : tick >= 1000000
                        ? numeral(tick).format("0.0a")
                        : tick.toLocaleString()
                  }
                  interval={0}
                  domain={yDomain}
                />
                {/* {negativeValue ? <ReferenceLine x={0} stroke='#000'/> : ""} */}
                <Tooltip content={<CustomToolTip />} />
                <Bar dataKey={"y"}></Bar>
              </BarChart>
            )}
          </AutoSizer>
        </div>
      </React.Fragment>
    );
  }
}

class BarGraphTitle extends React.PureComponent {
  render() {
    const { title, adjustAssumptions } = this.props;
    return (
      <div className={styles.barGraphTitleWrapper}>
        <div className={styles.barGraphTitle}>{title}</div>
        <a className={styles.barGraphAction} onClick={adjustAssumptions}>
          {"Adjust Assumptions"}
        </a>
      </div>
    );
  }
}
